import React from 'react';
import { ProjectReadView } from '@atlassian/jira-issue-field-project/src/ui/view/index.tsx';
import type { TransformedProjectOption } from '../../../../common/field-types/project/types.tsx';

type Props = { project?: TransformedProjectOption | null };

export const ProjectRead = ({ project }: Props) =>
	project ? <ProjectReadView value={project} /> : null;
